import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Option, Response, StaticMethods} from '../../model/GeneralModels';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ListService} from '../../services/list.service';
import {IntroductionLetterService} from '../../services/introduction-letter.service';

interface DialogData {
  productName: string;
  companyName: string;
  subsetID: number;
}

@Component({
  selector: 'app-introduction-letter-form',
  templateUrl: './introduction-letter-form.component.html',
  styleUrls: ['./introduction-letter-form.component.css']
})
export class IntroductionLetterFormComponent implements OnInit {

  formGroup: FormGroup = this.fb.group({
    letterTypeID: ['', Validators.required],
    stateID: ['', Validators.required],
    cityID: ['', Validators.required],
    centerName: ['', Validators.required]
  });
  letterTypeList: Option[] = [];
  stateList: Option[] = [];
  cityList: Option[] = [];
  productName: string;
  companyName: string;
  subsetID: number;

  constructor(
    public dialogRef: MatDialogRef<IntroductionLetterFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private fb: FormBuilder,
    private listService: ListService, private introductionLetterService: IntroductionLetterService) {
    this.productName = data.productName;
    this.companyName = data.companyName;
    this.subsetID = data.subsetID;
  }

  ngOnInit(): void {
    this.listService.getStateList(this.productName).subscribe(response => {
      this.stateList = [];
      for (let i = 0; i < response.data.states.length; i++) {
        this.stateList[i] = new Option(response.data.states[i].persianName, response.data.states[i].stateCode);
      }
    });
    this.introductionLetterService.getLetterTypeList(this.productName).subscribe((response: Response) => {
      if (response.success) {
        console.log(response);
        this.letterTypeList = [];
        response.data.forEach(object => {
          this.letterTypeList.push(new Option(object.label, object.value));
        });
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onStateChange(selectedStateID) {
    this.listService.getCityList(this.productName, parseInt(selectedStateID, 10)).subscribe((response: Response) => {
      if (!response.data.cities.length) {
        this.cityList[0] = new Option('', 'هشتگ بیمه استان انتخاب شده را پوشش نمی دهد');
      } else {
        this.cityList = response.data.cities;
        for (let i = 0; i < response.data.cities.length; i++) {
          this.cityList[i] = new Option(response.data.cities[i].persianName, response.data.cities[i].cityCode);
        }
      }
      this.formGroup.controls.cityID.patchValue('');
    });
  }

  getNewSubset() {
    if (this.formGroup.valid) {
      const form = this.formGroup.value;
      form.subsetID = this.subsetID;
      this.introductionLetterService.createNewLetterRequest(form).subscribe((response: Response) => {
        if (response.success) {
          this.dialogRef.close(true);
        }
      });
    } else {
      StaticMethods.showMessage('اطلاعات به درستی وارد نشده است');
    }
  }

}
